import IntentType from "../../../../../intentexecutor/utils/IntentType";
import { getCurrentTimeZone } from "../../../../../utils/dateutils";
import { executeIntent } from "../../../../utils/IntentExecutor";

export const processAction = async (action, actionData, userJson) => {
  let payload = {};
  switch (action.functionName) { 
    case "acceptOpportunity":
      payload = {
        opportunityIdentifier: actionData?.opportunityIdentifier,
        workforceIdentifier: userJson?.userIdentifier,
        shouldAcceptCompleteSchedule: false,
        creatorIdentifier: userJson?.userIdentifier,
      }
      return executeIntent(IntentType.ACCEPT_OPPORTUNITY, payload);
    case "rejectOpportunity":
      payload = {
        opportunityIdentifier: actionData?.opportunityIdentifier,
        workforceIdentifier: userJson?.userIdentifier,
        shouldRejectCompleteSchedule: false,
        creatorIdentifier: userJson?.userIdentifier,
        timeZoneId: getCurrentTimeZone(),
      }

      return executeIntent(IntentType.REJECT_OPPORTUNITY, payload);
    case "updateDeliveryStatus":
    case "editDeliveryForm":
      payload = {
        deliveryIdentifier: actionData?.deliveryIdentifier,
        deliveryStatus: action.to,
        creatorIdentifier: userJson?.userIdentifier,
      }
      return executeIntent(IntentType.UPDATE_DELIVERY, payload);
    case "approveDelivery":
      payload = {
        deliveryIdentifier: actionData?.deliveryIdentifier,
        deliveryStatus: action.to,
        comments: actionData?.comments,
        creatorIdentifier: userJson?.userIdentifier,
      }

      return executeIntent(IntentType.UPDATE_DELIVERY, payload);
    case "rejectDelivery":
      payload = {
        deliveryIdentifier: actionData?.deliveryIdentifier,
        deliveryStatus: action.to,
        comments: JSON.stringify(actionData?.comments),
        creatorIdentifier: userJson?.userIdentifier,
      }
      return executeIntent(IntentType.UPDATE_DELIVERY, payload);
    case "addDelivery":
      payload = {
        ...actionData,
        deliveryDate: actionData?.activityDate,
        startTime: actionData?.startTime,
        endTime: actionData?.endTime,
        serviceType: "delivery",
        creatorIdentifier: userJson?.userIdentifier,
      }
      return executeIntent(IntentType.ADD_DELIVERY, payload);
    case "updateDeliveryDetails":
      payload = {
        deliveryIdentifier: actionData?.deliveryIdentifier,
        deliveryDate: actionData?.deliveryDate,
        startTime: actionData?.startTime,
        endTime: actionData?.endTime,
        creatorIdentifier: userJson?.userIdentifier,
        timeZoneId: getCurrentTimeZone(),
      }
      return executeIntent(IntentType.UPDATE_DELIVERY, payload);
    case "navigateToMaps": 
      if (actionData?.patientIdentifier !== undefined) {
        const navigationPayload = {
          userIdentifier: actionData?.patientIdentifier,
          secretKey: userJson?.secretKey,
        };
        return executeIntent(IntentType.GET_PATIENT_DETAILS_BY_USER_IDENTIFIER, navigationPayload);
      } else {
        return new Error();
      }
    case "createVisits":
      payload = {
        organizationIdentifier: actionData?.organizationIdentifier,
        page: 1,
        workforceIdentifier: actionData?.workforceIdentifier,
        filters: {
          opportunityIdentifier: actionData?.opportunityIdentifier
        },
        secretKey: userJson?.secretKey,
        creatorIdentifier: userJson?.userIdentifier,
      }
      return executeIntent(IntentType.GET_DELIVERIES, payload);
    default:
      return () => {
        // Perform further actions for unknown function names
      };
  }
}